import GetRegisteredDeviceActions from "@frameworks/web/redux/feature/BasicProfile/actions/GetRegisteredDevices";
import GetProfilePicActions from "@frameworks/web/redux/feature/BasicProfile/actions/GetProfilePic";
import ClientDetailsGroupsActions from "@frameworks/web/redux/feature/BasicProfile/actions/ClientDetails";
import IGetRmDetailsGroupsActions from "@frameworks/web/redux/feature/BasicProfile/actions/GetRmDetails";
import DeleteProfilePicActions from "@frameworks/web/redux/feature/BasicProfile/actions/DeleteProfilePic";
import SaveProfilePicActions from "@frameworks/web/redux/feature/BasicProfile/actions/SaveProfilePic";
export default () => {
    return {
        basicProfile: {
            clientDetails: new ClientDetailsGroupsActions(),
            getRegisteredDeviceDetails: new GetRegisteredDeviceActions(),
            getRmDetails: new IGetRmDetailsGroupsActions(),
            getProfilePic: new GetProfilePicActions(),
            saveProfilePic: new SaveProfilePicActions(),
            deleteProfilePic: new DeleteProfilePicActions(),
        },
    };
};
